import { render, staticRenderFns } from "./Singerinfo.vue?vue&type=template&id=1186aff8&scoped=true&"
import script from "./Singerinfo.vue?vue&type=script&lang=js&"
export * from "./Singerinfo.vue?vue&type=script&lang=js&"
import style0 from "./Singerinfo.vue?vue&type=style&index=0&id=1186aff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186aff8",
  null
  
)

export default component.exports